import { render, staticRenderFns } from "./FuseeGelee.vue?vue&type=template&id=2ec544f3"
import script from "./FuseeGelee.vue?vue&type=script&lang=js"
export * from "./FuseeGelee.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports